// eslint-disable-next-line
import { h, Component } from 'preact';
import Header from './../Header';
import Hide from './../Hide';
import ProductList from '../ProductList';
import CartInfo from '../CartInfo';
import Checkout from '../Checkout';
import BindToElement from '../BindToElement';

import {
    ESC_KEY_CODE,
    CART_BUTTON_SELECTOR,
    MINICART_POPUP_TIP_MARGIN,
    MINICART_POPUP_TIP_CENTER_OFFSET,
    MINICART_POPUP_TIP_HEIGHT,
    MINICART_WIDTH,
} from '../../consts';

import styles from './index.scss';

class MiniCart extends Component {
    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('keydown', this.handleESCKey);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('keydown', this.handleESCKey);
    }

    /**
     * Gets number of visible and hidden items
     * @param isMobile {boolean} - whether it is mobile or desktop resolution right now
     * @returns {Object} - number of items to show and number of hidden items
     */
    getNumbersOfItemsObj(isMobile) {
        const {
            order: { numberOfItems },
            numberOfDisplayedItemsDesktop = 3,
            numberOfDisplayedItemsMobile = 2,
        } = this.props;

        const numberOfItems_num = +numberOfItems;
        const numberOfDisplayedItemsDesktop_num = +numberOfDisplayedItemsDesktop;
        const numberOfDisplayedItemsMobile_num = +numberOfDisplayedItemsMobile;

        if (isMobile) {
            if (numberOfItems_num <= numberOfDisplayedItemsMobile_num) {
                return {
                    visible: numberOfItems_num,
                    hidden: 0,
                };
            }
            return {
                visible: numberOfDisplayedItemsMobile_num,
                hidden: numberOfItems_num - numberOfDisplayedItemsMobile_num,
            };
        }
        if (numberOfItems_num <= numberOfDisplayedItemsDesktop_num) {
            return {
                visible: numberOfItems_num,
                hidden: 0,
            };
        }
        return {
            visible: numberOfDisplayedItemsDesktop_num,
            hidden: numberOfItems_num - numberOfDisplayedItemsDesktop_num,
        };
    }

    /**
     * Renders MiniCart component
     * @param x - coordinate x
     * @param y - coordinate y
     * @param isMobile {boolean} - whether mobile resolution or not
     * @returns {*}
     */
    renderMiniCart = ({ x, y, isMobile }) => {
        if (!this.props.showMiniCart) {
            return null;
        }

        const {
            isTradeUpsCart,
            isValidCart,
            isEcommerceSite,
            expressCheckoutEnabled,
            standardCheckout,
            expressCheckout,
            shoppingCartUrl,
            siteId,
            order,
            labels,
        } = this.props;

        const left = x - MINICART_WIDTH + MINICART_POPUP_TIP_CENTER_OFFSET;
        const top = y + MINICART_POPUP_TIP_HEIGHT + MINICART_POPUP_TIP_MARGIN;

        const style = {
            top: `${top}px`,
        };
        if (!isMobile) {
            style.left = left;
        }

        return (
            <div className={styles.MiniCart} style={style}>
                <div className={styles.MiniCartInner}>
                    <Header
                        onClose={this.props.onClose}
                        numberOfItems={order.numberOfItems}
                        numberOfUnavailableItems={order.numberOfUnavailableItems}
                        {...labels}
                    />
                    <div className={styles.content}>
                        <ProductList
                            isMobile={isMobile}
                            numbersOfItemsObj={this.getNumbersOfItemsObj(isMobile)}
                            {...order}
                            labels={labels}
                        />
                        <CartInfo
                            isMobile={isMobile}
                            numbersOfItemsObj={this.getNumbersOfItemsObj(isMobile)}
                            orderTotalAmount={order.orderTotalAmount}
                            orderIsEstimatedTotal={order.isEstimatedTotal}
                            {...labels}
                        />
                        <Checkout
                            isTradeUpsCart={isTradeUpsCart}
                            isValidCart={isValidCart}
                            isEcommerceSite={isEcommerceSite}
                            expressCheckoutEnabled={expressCheckoutEnabled}
                            checkoutButton={standardCheckout}
                            expressCheckoutButton={expressCheckout}
                            shoppingCartUrl={shoppingCartUrl}
                            siteId={siteId}
                            {...labels}
                        />
                    </div>
                </div>
                <Hide {...labels} onHidePromptAction={this.props.onHidePromptAction} />
            </div>
        );
    };

    handleESCKey = ev => {
        if (ev.keyCode === ESC_KEY_CODE) {
            this.props.onClose();
        }
    };

    handleOutsideClick = ev => {
        const { target } = ev;
        const insideMiniCart = target.classList.contains(styles.MiniCart) || target.closest(`.${styles.MiniCart}`);
        const clickOnTriggerButton = target.matches(CART_BUTTON_SELECTOR);

        if (!insideMiniCart && !clickOnTriggerButton) {
            this.props.onClose();
        }
    };

    render() {
        return <BindToElement elementSelector="#cart-button">{this.renderMiniCart}</BindToElement>;
    }
}

export default MiniCart;
